<template>
    <section class="a-news">
        <h2 class="a-news__title">{{ newsData.title }}</h2>
        <div class="a-news__wrapper">
            <news-item
                :items-data="newsDataItems"
                :fixed-new="newsData.jsonFixedNew" />
        </div>
        <a
            class="a-news__button"
            :href="newsData.button.href"
            :title="newsData.button.text">
            {{ newsData.button.text }}
        </a>
    </section>
</template>

<script>
    import NewsItem from './NewsItem'

    export default {
        name: 'News',
        props: {
            newsData: Object,
            newsDataItems: Object
        },
        components: {
            NewsItem
        },
    }
</script>